/**
 * Orquestación legacy public: mismo pipeline que application con listas public.
 *
 * @see doc/frontend/LEGACY_BRIDGE.md
 */
import { Cifra } from '@/legacy/globals';
import { loadI18nTranslations, syncWindowI18n } from '@/libs/i18n';
import {
  ensureCifraAppNamespace,
  registerGlobalsSkeleton,
  syncGlobalsFromWindow,
} from '@/legacy/registry';
import { loadVendorYarnCore } from '@/legacy/vendor_yarn_core';

export async function bootLegacyPublic() {
  registerGlobalsSkeleton();
  syncWindowI18n();
  void Cifra;

  await loadVendorYarnCore();

  const { default: cargarJqueryUi } = await import('@/legacy/umd/cargar_jquery_ui');
  await cargarJqueryUi();

  await import('bootstrap');

  await import('virtual:legacy-vendor-rest-public');
  syncGlobalsFromWindow();

  await loadI18nTranslations();

  ensureCifraAppNamespace();

  await import('@/legacy/app/boot_public_scripts');

  syncGlobalsFromWindow();
  ensureCifraAppNamespace();
}
